import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b3af38de"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3af38de')) {
      api.createRecord('b3af38de', component.options)
    } else {
      api.reload('b3af38de', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b3af38de", function () {
      api.rerender('b3af38de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/entryDesign/index.vue"
export default component.exports